import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Verify.css";
import Button from "../components/Button";

import { API_BASE } from "../utils/apiConfig";

export default function VerifyEmail({ onAuth }) {
  const [status, setStatus] = useState("loading");
  const [email, setEmail] = useState("");
  const [verifiedEmail, setVerifiedEmail] = useState("");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");

    if (!token) {
      setStatus("error");
      return;
    }

    axios
      .post(`${API_BASE}/auth/verify-email`, { token })
      .then((response) => {
        setVerifiedEmail(response.data?.email || "");
        setStatus("success");
      })
      .catch(() => {
        setStatus("error");
      });
  }, [onAuth]);

  const [resending, setResending] = useState(false);

  const resend = async () => {
    const normalizedEmail = email.trim().toLowerCase();
    if (!normalizedEmail) return;

    try {
      setResending(true);
      await axios.post(`${API_BASE}/auth/resend-verification`, { email: normalizedEmail });
      setStatus("resent");
    } catch {
      setStatus("error");
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="verify-page">
      <div className="verify-card">

        {status === "loading" && (
          <>
            <div className="verify-spinner" aria-hidden="true" />
            <h2>Verifying email…</h2>
            <p className="subtitle">Please wait</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="verify-icon" aria-hidden="true">✓</div>
            <h2>Email verified</h2>
            <p className="subtitle">
              Your account is active. You can now sign in to LogicLine.
            </p>
            <Button
              className="verify-btn"
              onClick={() => onAuth("login", { email: verifiedEmail })}
            >
              Continue to sign in
            </Button>
          </>
        )}

        {status === "resent" && (
          <>
            <div className="verify-icon" aria-hidden="true">✓</div>
            <h2>Verification email sent</h2>
            <p className="subtitle">Please check your inbox and spam or junk folder, then open the new verification link.</p>
            <Button className="verify-btn" onClick={() => onAuth("login", { email: email.trim().toLowerCase() })}>Return to sign in</Button>
          </>
        )}

        {status === "error" && (
          <>
            <h2>Verification failed</h2>
            <p className="subtitle">
              This verification link is invalid or already used.
            </p>

            <input
              className="verify-input"
              placeholder="Enter your email to resend verification"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button
              className="verify-btn"
              onClick={resend}
              loading={resending}
            >
              Resend verification email
            </Button>

            <p className="verify-footer">
              Or <span onClick={() => onAuth("login")}>return to sign in</span>
            </p>
          </>
        )}

      </div>
    </div>
  );
}
